// extracted by mini-css-extract-plugin
module.exports = {"root":"Settings_root__1B1V1","search":"Settings_search__31IqQ","filter":"Settings_filter__1BOu_"};